"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get addNonceToUrl () {
        return addNonceToUrl;
    },
    get customMapConfig () {
        return customMapConfig;
    },
    get generateDisplayName () {
        return generateDisplayName;
    },
    get textColor () {
        return textColor;
    },
    get textFont () {
        return textFont;
    },
    get textHaloColor () {
        return textHaloColor;
    },
    get textOpacity () {
        return textOpacity;
    },
    get transparent () {
        return transparent;
    }
});
const _constants = require("common/constants");
const _queryBuilder = require("common/utils/queryBuilder");
const _styling = require("./styling");
const cleanType = (content)=>content;
const textColor = "#ffffff";
const textFont = [
    "DIN Offc Pro Bold",
    "Arial Unicode MS Regular"
];
const textHaloColor = "hsla(0, 0%, 2%, 0.82)";
const transparent = _constants.DEFAULT_MAP_STYLES.fillColor;
const textOpacity = cleanType([
    "step",
    [
        "zoom"
    ],
    0,
    12,
    1
]);
const includePointFilter = cleanType([
    "==",
    [
        "geometry-type"
    ],
    "Point"
]);
const includeMultiPointFilter = cleanType([
    "==",
    [
        "geometry-type"
    ],
    "MultiPoint"
]);
const includeLineStringFilter = cleanType([
    "==",
    [
        "geometry-type"
    ],
    "LineString"
]);
const includeMultiLineStringFilter = cleanType([
    "==",
    [
        "geometry-type"
    ],
    "MultiLineString"
]);
const includePolygonFilter = cleanType([
    "==",
    [
        "geometry-type"
    ],
    "Polygon"
]);
const includeMultiPolygonFilter = cleanType([
    "==",
    [
        "geometry-type"
    ],
    "MultiPolygon"
]);
const clickFilter = cleanType([
    "==",
    [
        "feature-state",
        "click"
    ],
    true
]);
const hoverFilter = cleanType([
    "==",
    [
        "feature-state",
        "hover"
    ],
    true
]);
const customMapConfig = {
    lineColor: cleanType([
        "coalesce",
        [
            "get",
            "lineColor"
        ],
        [
            "get",
            "fillColor"
        ],
        _constants.DEFAULT_MAP_STYLES.lineColor
    ]),
    lineOpacity: cleanType([
        "case",
        [
            "any",
            clickFilter,
            hoverFilter
        ],
        _constants.DEFAULT_MAP_STYLES.lineOpacity,
        [
            "to-number",
            [
                "coalesce",
                [
                    "get",
                    "lineOpacity"
                ],
                _constants.DEFAULT_MAP_STYLES.lineOpacity
            ]
        ]
    ]),
    getLineWidth: ({ defaultWidth = 0, minWidth = 0 })=>cleanType([
            "max",
            minWidth,
            [
                "to-number",
                [
                    "coalesce",
                    [
                        "get",
                        "lineWidth"
                    ],
                    defaultWidth
                ]
            ]
        ]),
    getLineInteractionWidth: ({ defaultWidth = 0, minWidth = 0 })=>cleanType([
            "+",
            [
                "max",
                minWidth,
                [
                    "to-number",
                    [
                        "coalesce",
                        [
                            "get",
                            "lineWidth"
                        ],
                        defaultWidth
                    ]
                ]
            ],
            1
        ]),
    getFeatureColorForState: ({ defaultColor })=>cleanType([
            "case",
            customMapConfig.clickFilter,
            _styling.primitiveColors.blue500,
            customMapConfig.hoverFilter,
            _styling.primitiveColors.blue200,
            defaultColor
        ]),
    id: cleanType([
        "get",
        "id"
    ]),
    textField: cleanType([
        "get",
        "label"
    ]),
    fillColor: cleanType([
        "coalesce",
        [
            "get",
            "fillColor"
        ],
        transparent
    ]),
    fillOpacity: cleanType([
        "to-number",
        [
            "coalesce",
            [
                "get",
                "fillOpacity"
            ],
            _constants.DEFAULT_MAP_STYLES.fillOpacity
        ]
    ]),
    fillPattern: cleanType([
        "case",
        [
            "has",
            "fillColor"
        ],
        "",
        "shape-line"
    ]),
    iconImage: cleanType([
        "case",
        [
            "has",
            "icon"
        ],
        [
            "get",
            "icon"
        ],
        _constants.DEFAULT_MAP_STYLES.icon
    ]),
    iconImageFilled: cleanType([
        "case",
        [
            "has",
            "icon"
        ],
        [
            "concat",
            [
                "get",
                "icon"
            ],
            "-filled"
        ],
        `${_constants.DEFAULT_MAP_STYLES.icon}-filled`
    ]),
    iconSize: cleanType([
        "to-number",
        [
            "coalesce",
            [
                "get",
                "iconSize"
            ],
            _constants.DEFAULT_MAP_STYLES.iconSize
        ]
    ]),
    includePointFilter,
    includeMultiPointFilter,
    includeAllPointFilter: cleanType([
        "any",
        includePointFilter,
        includeMultiPointFilter
    ]),
    includeLineStringFilter,
    includeMultiLineStringFilter,
    includeAllLineStringFilter: cleanType([
        "any",
        includeLineStringFilter,
        includeMultiLineStringFilter
    ]),
    includePolygonFilter,
    includeMultiPolygonFilter,
    includeAllPolygonFilter: cleanType([
        "any",
        includePolygonFilter,
        includeMultiPolygonFilter
    ]),
    clickFilter,
    hoverFilter
};
const addNonceToUrl = (url, nonce)=>{
    const parsed = new URL(url);
    parsed.searchParams.set("nonce", nonce);
    return decodeURI(parsed.toString());
};
const generateDisplayName = ({ name, query, customObjectGroups = [] })=>{
    return `${(0, _queryBuilder.generateTableLabel)(query.source, customObjectGroups)} - ${name}`;
};

//# sourceMappingURL=data:application/json;base64,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